module.exports = __webpack_public_path__ + "img/EN-邀请2.d150fdaa.png";